module.exports = __webpack_public_path__ + "img/orthogonal-view.9e68abd0.svg";